
<nav>
    <ul class="pagination">
      <li class="page-item" [ngClass]="{'disabled': currentPage === 1}">
        <a class="page-link" (click)="changePage(currentPage - 1)">Previous</a>
      </li>
      <li class="page-item" [ngClass]="{'disabled': currentPage === totalPages}">
        <a class="page-link" (click)="changePage(currentPage + 1)">Next</a>
      </li>
    </ul>
  </nav>
  